// นามสกุลจากชื่อหรือ path เช่น "ตจ4.PDF" -> "pdf" ; ไม่มีนามสกุลได้ ""
const extensionOf = (name) =>
  /\.([a-z0-9]{1,5})$/i.exec(name ?? "")?.[1]?.toLowerCase() ?? "";

// ใบอนุญาตที่ระบบสร้างก่อนแก้ ไม่มีนามสกุลในชื่อ (FilePath มี .pdf) จึงใช้นามสกุลจาก FilePath แทน
export const fileExtension = (file) =>
  extensionOf(file?.FileName) || extensionOf(file?.FilePath);

// ชื่อตอนบันทึกไฟล์ต้องมีนามสกุล ไม่งั้นเบราว์เซอร์บันทึกเป็น .txt แล้วเปิดไม่ได้
export const downloadFileName = (file) => {
  const name = file?.FileName || "file";
  const extension = fileExtension(file);
  if (extensionOf(name) || !extension) {
    return name;
  }
  return `${name}.${extension}`;
};

// สำเนาใบอนุญาตที่สิ้นอายุ: ผู้ใช้อัปโหลดเอง หรือระบบดึงให้ตอนกด "ใช้ไฟล์จากระบบ"
const EXPIRED_LICENSE_FILE_TYPES = new Set([
  "ExpiredAgentExtFiles",
  "ExpiredAgentExtFile",
]);
export const isExpiredLicenseFile = (file) =>
  EXPIRED_LICENSE_FILE_TYPES.has(file?.FileType);
